import React, {useState, useCallback, useEffect, forwardRef, useImperativeHandle} from "react";
import Select from "react-select";
import debounce from "lodash.debounce";
import ApiService from "../../util/ApiService";
import AuthService from "../../util/AuthService";

const UsersSearch = forwardRef(({
                                    onUserSelect,
                                    initialUser = null, // Usuário inicial, opcional
                                    buttonAdd = false,
                                    statusTitle = true,
                                    initialUserEditable = false,
                                    departmentId = null,
                                    title = "Usuário",
                                    allTypes = [1],
                                    situation = null,
                                    autoSelectFirst = false,
                                }, ref) => {
    const [users] = useState(AuthService.getUserData());
    const [userSelected, setUserSelected] = useState(null);
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState("");

    // Configurar usuário inicial ao carregar
    useEffect(() => {
        if (initialUser) {
            setUserSelected({
                value: initialUser.id,
                label: initialUser.name,
                email: initialUser.email,
                cpf: initialUser.cpf,
                city: initialUser.city,
                state: initialUser.state,
            });
        }
    }, [initialUser]);

    // Função para buscar usuários com base no termo de pesquisa
    const fetchSuggestions = async (searchTerm) => {
        setLoading(true);

        console.log(searchTerm);
        console.log(situation);
        const param = {
            name: searchTerm, // Parâmetro de busca
            userId: users?.id,
            allTypes: allTypes,
            departmentId: departmentId || null,
        };

        if (situation) {
            param.situation = situation;
        }

        try {
            const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}documents/getfromcompany`, param, false);
            const {data} = ApiService.handleApiResponse(response);

            const formattedSuggestions = data.map(item => ({
                value: item?.user_info?.id || item?.id,
                label: item?.user_info?.name || item?.name,
                email: item?.user_info?.email || item?.email,
                cpf: item?.user_info?.cpf || item?.cpf,
                city: item?.user_info?.city || item?.city,
                state: item?.user_info?.state || item?.state,
                due_date: item.due_date
            }));
            setSuggestions(formattedSuggestions);

            if (autoSelectFirst && formattedSuggestions.length > 0) {
                handleUserSelect(formattedSuggestions[0]);
            }

        } catch (error) {
            ApiService.handleApiError(error);
            setSuggestions([]);
        } finally {
            setLoading(false);
        }
    };

    const debouncedFetchSuggestions = useCallback(debounce(fetchSuggestions, 500), []);

    const handleInputChange = (inputValue) => {
        setInputValue(inputValue);

        if (inputValue) {
            debouncedFetchSuggestions(inputValue);
        } else {
            setSuggestions([]); // Limpar sugestões ao apagar o texto
        }
    };

    const handleUserSelect = (selectedOption) => {
        setUserSelected(selectedOption); // Atualizar seleção atual
        if (onUserSelect) {
            onUserSelect(selectedOption); // Notificar componente pai
        }
    };

    const handleClearSelection = () => {
        setUserSelected(null);
        setInputValue("");
        setSuggestions([]);
        if (onUserSelect) {
            onUserSelect(null);
        }
    };

    // Permitir que o componente pai limpe a seleção
    useImperativeHandle(ref, () => ({
        clearUser() {
            handleClearSelection();
        },
    }));

    return (
        <div className="form-group" style={{position: "relative"}}>
            {statusTitle && <label>{title}</label>}
            <div className="user-input-group d-flex align-items-center">
                <Select
                    placeholder="Nome do usuário"
                    value={userSelected}
                    onInputChange={handleInputChange}
                    onChange={handleUserSelect}
                    options={suggestions}
                    isDisabled={Boolean(initialUser) && initialUserEditable}
                    isClearable
                    isLoading={loading}
                    noOptionsMessage={() => "Nenhum usuário encontrado"}
                    loadingMessage={() => "Carregando..."}
                    filterOption={() => true} // <- força aceitar resultados fora da ordem digitada
                    formatOptionLabel={(option) => (
                        <div>{option.label}</div> // <- só mostra o nome
                    )}
                    menuPortalTarget={document.body}
                    styles={{
                        container: (provided) => ({ ...provided, flex: 1 }),
                        control: (provided) => ({ ...provided, minHeight: "38px" }),
                        menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                    }}
                />

            </div>
        </div>
    );
});

export default UsersSearch;
